import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import { ThemeProvider, useTheme } from "./components/ThemeContext";

import { Footer } from "./components/Footer";
import DotGrid from "./components/backgrounds/DotGrid";
import { PageHeader } from "./components/PageHeader";
import SEO from "./components/SEO";
import Healthcare from "./pages/HealthCare";
import InvestorPortal from "./pages/InvestorPortal";
import PatientsPage from "./pages/PatientsPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import AutomatedVideoCreation from "./pages/AutomatedVideoCreation";
import HelpPage from "./pages/HelpPage";
import WelwynnPage from "./pages/WelwynnPage";
import DownloadPage from "./pages/DownloadPage";
import FeaturesPage from "./pages/FeaturesPage";

function SocialPage() {
  return (
    <div className="w-full h-screen h-dvh">
      <SEO
        title="Quilt Social App"
        description="Interactive social experience powered by Quilt for personalized health and wellness."
        path="/social"
      />
      <PageHeader navItems={[]} />
      <iframe
        src="https://quilt-website-vmll.vercel.app/"
        title="Social App"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
}

function AppContent() {

  const { theme } = useTheme();
  // Clinic landing pages have their own header, footer and a quieter background
  const path = useLocation().pathname.replace(/\/$/, "");
  const clinicPage = path === "/welwynn";
  // The features page brings its own silk background instead of the dots
  const showDots = !clinicPage && path !== "/features";

  return (
    <div
      className={
        theme === 'dark'
          ? "min-h-screen bg-gradient-to-br from-black via-slate-950 to-black"
          : "min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 light"
      }
    >
      {/* <Header /> */}
      {showDots && <div style={{ width: '100vw', height: '100vh', position: 'fixed' }}>
        <DotGrid
          dotSize={3}
          gap={25}
          baseColor={theme === 'dark' ? "#1D1720" : "#DADBDC"}
          activeColor={theme === 'dark' ? "#8B1FA6" : "#8B1FA6"}
          proximity={120}
          shockRadius={250}
          shockStrength={5}
          resistance={750}
          returnDuration={1.5}
        />
      </div>}
      <main className="relative">

        <Routes>
          <Route path="/" element={<PatientsPage />} />
          <Route path="/social" element={<SocialPage />} />
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/vision" element={<InvestorPortal />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/getting-started/automated-video" element={<AutomatedVideoCreation />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/support" element={<HelpPage />} />
          {/* Unlisted clinic page: noindex, not linked from the nav */}
          <Route path="/welwynn" element={<WelwynnPage />} />
          {/* QR code target: phones are redirected to their store by index.html before this renders */}
          <Route path="/download" element={<DownloadPage />} />
          {/* Work in progress: unlisted, noindex */}
          <Route path="/features" element={<FeaturesPage />} />
        </Routes>


      </main>
      {!clinicPage && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider children={<AppContent />} />
    </BrowserRouter>
  );
}
